export default __webpack_public_path__ + "static/media/Toestellen.cb1aec08.svg";